import { loadModules } from 'esri-loader';

const state = {
	transparentSymbol			:   null,
	planLineSymbol          	:   null,
	graySymbol  				:   null,
	whiteSymbol  				:   null,
	redSymbol					:   null,
	roomHoverSymbol         	:   null,
	interiorSymbol 				:   null,
	buildingHighlightSymbol 	:  	null,
	buildingHighlightSymbol2  	:  	null,
	buildingHoverHighlightSymbol:   null,
}

const actions = {
  	setupSymbols({state, rootState}) {
  		loadModules(['esri/symbols/TextSymbol', 'esri/Color', 'esri/symbols/SimpleFillSymbol', 
  			'esri/symbols/SimpleLineSymbol'])
  		.then(([TextSymbol, Color, SimpleFillSymbol, SimpleLineSymbol]) => {
  			//console.log("Setup Symbols")

	  		// TRANSPARENT	  		 
	  		state.transparentSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([0, 0, 0, 1]), 1),
			new Color([255, 0, 0, 0]));

			// WHITE
	  		state.whiteSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 0, 0, 0, .5 ]), .5),
			new Color([ 255, 255, 255, 1 ]))

			// INTERIOR
	  		state.interiorSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 0, 0, 0, .5 ]), 1),
			new Color([ 250, 255, 250, 1 ]));
			//new Color([ 250, 255, 250, rootState.mapUi.clientLabels ? 1 : 0 ]));

			// DARK INTERIOR
	  		state.darkInteriorSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 255, 0, 0, 1 ]), .5),
			new Color([ 20, 20, 20, 1 ]));

			// PLAN LINE
	  		state.planLineSymbol = new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 0, 0, 0, .5 ]), 1)

	  		// DARK PLAN LINE
	  		state.darkPlanLineSymbol = new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 255, 0, 0, .5 ]), .5)

			// GRAY
	  		state.graySymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 0, 0, 0, .5 ]), 1),
			new Color([ 200, 200, 200, 1 ]));

			// DARK GRAY
	  		state.darkGray = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 0, 0, 0, .5 ]), 1),
			new Color([ 30, 30, 30, 1 ]));

			// Darker Gray w Red
	  		state.darkerGray = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 255, 0, 0, 1 ]), .5),
			new Color([ 10, 10, 10, 1 ]));

			// NULL (Unassocitated) ROOM
	  		state.nullSymbol = new SimpleFillSymbol(SimpleFillSymbol.STYLE_BACKWARD_DIAGONAL,
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 0, 0, 0, 1 ]), 1),
			new Color([ 100, 100, 100, .5 ]));

			// RED
	  		state.redSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 200, 0, 0, 1 ]), 4),
			new Color([ 150,0, 0, 0 ]));

			// ROOM HOVER
	  		state.roomHoverSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color("purple"), 4),
			new Color([ 0,0,0,0 ]));

			// BUILDING HIGHLIGHT
	  		state.buildingHighlightSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 0,0,0,1 ]), 4),
			new Color([ 0,0,0,0 ]));

			// BUILDING HIGHLIGHT2
	  		state.buildingHighlightSymbol2 = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 0,0,0,.2 ]), 15),
			new Color([ 0,0,0,0 ]));

			// BUILDING HOVER HIGHLIGHT
	  		state.buildingHoverHighlightSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([ 0,0,255,.15 ]), 10),
			new Color([ 0,0,0,0 ]));
		})
	},
}

export default {
	state,
	//getters,
	actions,
	//mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/mapSymbols.js